import api from "./baseApi";

export const arrivalApi = {
  getDeliveryStatus() {
    return api.get("/div/delivery-status");
  },
  getListArrival(params, config = {}) {
    return api.get("/service-instructs/arrival-status", { ...config, params });
  },
  downloadSignImage(params) {
    return api.get(`/service-instructs/${params}/download-sign-images/pdf`, {
      responseType: "blob"
    });
  },
  updateDeliStatus(id, params) {
    return api.patch(`/service-instructs/${id}`, params);
  }
};
